import _ from "lodash";
import IRole = User.IRole;
import { Employe } from "./Employe";
import { Contact } from "./Contact";

export class User {
    id?: number;
    name: string = "";
    email: string = "";
    private _roles: Array<number> = [];
    link_id?: number;
    link_type_str?: User.ELinkType;
    link?: Employe | Contact;

    constructor(data: any) {
        var self = this;
        _.assign(this, data);
        if (data.link) {
            if (self.link_type_str == User.ELinkType.Employe) {
                self.link = new Employe(data.link);
            } else if (self.link_type_str == User.ELinkType.Syndic) {
                self.link = new Contact(data.link);
            }
        }
    }

    //
    get roles(): Array<number> {
        return this._roles;
    }

    set roles(value: Array<number>) {
        let externalRole = _.find(value, function (rId) {
            let role = User.Role[rId];
            return role.type == User.ERoleType.Externe;
        });
        if (externalRole) {
            value = [externalRole];
        }
        this._roles = value;
    }

    get rolesDisplay(): Array<IRole> {
        return _.map(this._roles, function (rId) {
            return User.Role[rId];
        });
    }

    get isAdmin(): boolean {
        return this.hasRole(User.ERole.Admin);
    }

    hasRole(rId: User.ERole): boolean {
        return this.roles && this.roles.includes(rId);
    }
}

// Enums
export namespace User {
    // Roles
    export interface IRole {
        id: ERole;
        name: string;
        colorClass: string;
        type: ERoleType;
    }

    export enum ERole {
        Admin = 1,
        Mobile = 2,
        Rh = 3,
        Intervention = 4,
        Contact = 5,
        ControleQualite = 7,
        DesktopUser = 10,
        Syndic = 20,
    }

    export enum ERoleType {
        Interne = 1,
        Externe = 2,
    }

    export const Role: { [index: number]: IRole } = {
        [ERole.Admin]: {
            id: ERole.Admin,
            name: "Admin",
            colorClass: "danger",
            type: ERoleType.Interne,
        },
        [ERole.Mobile]: {
            id: ERole.Mobile,
            name: "Mobile",
            colorClass: "info",
            type: ERoleType.Interne,
        },
        [ERole.ControleQualite]: {
            id: ERole.ControleQualite,
            name: "Contrôle",
            colorClass: "warning",
            type: ERoleType.Interne,
        },
        [ERole.DesktopUser]: {
            id: ERole.DesktopUser,
            name: "Utilisateur web",
            colorClass: "success",
            type: ERoleType.Interne,
        },
        /*[ ERole.Rh ] : { id : ERole.Rh, name : 'RH', colorClass : 'primary', type : ERoleType.Interne },
        [ ERole.Intervention ] : { id : ERole.Intervention, name : 'Intervention', colorClass : 'primary', type : ERoleType.Interne },
        [ ERole.Contact ] : { id : ERole.Contact, name : 'Contact', colorClass : 'primary', type : ERoleType.Interne },*/
        [ERole.Syndic]: {
            id: ERole.Syndic,
            name: "Syndic",
            colorClass: "success",
            type: ERoleType.Externe,
        },
    };

    // Link
    export enum ELinkType {
        Employe = "employe",
        Syndic = "syndic",
    }
}
